module.exports = __webpack_public_path__ + "img/signup.e2a8854a.png";